import { openAuthPopup } from './auth'
import { getApiUrl } from './api'
import config from '../config'
import 'isomorphic-fetch'

export function getOrcidUrl(path, isSandbox) {
  return (isSandbox ? 'https://sandbox.orcid.org' : 'https://orcid.org') + path
}

export function createOrcidLinkHandler(
  options = {
    queryString: '',
    forceLogout: false,
  }
) {
  return async event => {
    event.preventDefault()
    if (options.forceLogout) {
      // Race condition: this should use `await` but some popup blockers
      // prevent use of window.open after the Promise resolves
      fetch(
        getOrcidUrl('/userStatus.json?logUserOut=true', !config.env.production),
        { credentials: 'include' }
      )
    }
    openAuthPopup(
      getApiUrl(
        '/orcid/link' + (options.queryString ? '?' + options.queryString : '')
      )
    )
  }
}
